export const fetchStoryBlockImage = async slug => {
  try {
    const response = await fetch("https://api.storyblok.com/v2/cdn/stories/".concat(slug, "?token=").concat(process.env.NEXT_PUBLIC_STORYBLOK_TOKEN, "&version=published"));
    if (!response.ok) {
      console.warn("Storyblok API returned status ".concat(response.status, " for slug: ").concat(slug));
      return null;
    }
    const data = await response.json();

    // Check if the response is an array (usually indicates an error)
    if (Array.isArray(data)) {
      console.warn("Storyblok API error for slug \"".concat(slug, "\":"), data[0] || 'Unknown error');
      return null;
    }
    if (!data || !data.story || !data.story.content || !data.story.content.body || !data.story.content.body[0] || !data.story.content.body[0].src) {
      console.warn("Invalid response structure from Storyblok API for slug \"".concat(slug, "\""));
      return null;
    }
    return data.story.content.body[0].src.url;
  } catch (error) {
    console.error('Error fetching Storyblok image:', error);
    return null;
  }
};